import FnrTypography from "FnrTypography";
import { usePostTwoFactorAuth } from "Login/TwoFA/API/queries";
import { use2FAState } from "Login/TwoFA/API/queryHooks";
import { useTwoFAContext } from "Login/TwoFA/TwoFA";
import { welcomeMessageComponentKeys as componentKeys } from "Login/TwoFA/constants";
import { useActiveWelcomeMessageKey } from "Login/TwoFA/stateHooks";

import FnrSlides from "UI/FnrSlides";

const componentsConfig = [
  {
    key: componentKeys.withoutName,
    value: () => null,
  },
  {
    key: componentKeys.withName,
    value: ({ userFullName, ...props }) => (
      <FnrTypography {...props}>
        Hello, {userFullName}! Welcome back.
      </FnrTypography>
    ),
  },
  {
    key: componentKeys.withCustomText,
    value: ({ headerText, ...props }) => (
      // The space string (" ") preserves the real estate during the transition should headerText be set to an empty string.
      <FnrTypography {...props}>{headerText || " "}</FnrTypography>
    ),
  },
];

const WelcomeMessage = () => {
  const [{ userFullName }] = use2FAState();
  const { headerText, variant } = useTwoFAContext();

  const activeKey = useActiveWelcomeMessageKey();

  const { isInitialLoading } = usePostTwoFactorAuth({ variant });
  if (isInitialLoading || headerText === false) return null;

  return (
    <FnrSlides
      activeKey={activeKey}
      // These props are passed down to the components.
      data-cy="TwoFA_WelcomeMessage"
      clip={false}
      type="accent"
      bold={false}
      fullWidth
      headerText={headerText}
      userFullName={userFullName}
      components={componentsConfig}
    />
  );
};

export default WelcomeMessage;
